import { defaultMember, teamShape } from '@/assets/imgs'
import { LazyImage } from './LazyImage'
import Image, { StaticImageData } from 'next/image'

type Props = {
  role: string
  name: string
  img: string | StaticImageData
}

const MemberCard = ({ role, name, img }: Props) => {
  return (
    <div className='flex cursor-grab flex-wrap justify-center gap-9 px-6 sm:px-14 md:px-16'>
      <div className='relative flex flex-col items-center gap-0'>
        <div className='relative'>
          <Image
          alt='team shape'
            src={teamShape}
            className='absolute bottom-2 -z-10 lg:left-0 lg:max-w-72'
          />
          <div className='w-60 sm:w-72 md:w-72 lg:max-w-72'>
            <LazyImage
            alt='Member'
              fallback={defaultMember}
              src={img}
              className='z-50 h-full w-full object-cover'
            />
          </div>
        </div>
        <div className='flex flex-col items-center'>
          <h3 className='text-2xl font-bold'>{name}</h3>
          <p className='text-lg'>{role}</p>
        </div>
      </div>
    </div>
  )
}

export default MemberCard
